import {Component, Input, OnInit} from '@angular/core';
import {HttpParams} from '@angular/common/http';
import {Router} from '@angular/router';
import {Clipboard} from '@angular/cdk/clipboard';
import {ToastService} from 'angular-toastify';

export class ContentRowField<T> {

  public link: (row: T) => string;
  public hidden?: (row: T) => boolean;
  public cell: (row: T) => string;
  public cellFlag?: (row: T) => string;
  public cellColor?: (row: T) => string;
  public copyCellActive?: ((row: T) => boolean) | boolean;
  public copyCellContent?: (row: T) => string;
  public cellBackgroundColor?: (row: T) => string;
  public cellPadding?: (row: T) => number;
  public cellBorderRadius?: (row: T) => number;
  public icon?: (row: T) => string;
  public iconColor?: (row: T) => string;
  public queryParams?: (row: T) => object;
  public header!: string;
  public columnDef!: string;

  public cell2?: (row: T) => string;
  public cell2Color?: (row: T) => string;
  public link2?: (row: T) => string;
  public queryParams2?: (row: T) => object;

  public type?: () => string;
  public isExternalLink?: ((row: T) => boolean) | boolean;

  public sortable: boolean;

}


@Component({
  selector: 'app-content-row',
  templateUrl: './content-row.component.html',
  styleUrls: ['./content-row.component.css']
})
export class ContentRowComponent implements OnInit {

  @Input() field: ContentRowField<any>;
  @Input() entity: any;

  constructor(
    private router: Router,
    private clipboard: Clipboard,
    private toaster: ToastService
  ) {
  }

  ngOnInit() {
  }

  isUrl(field: ContentRowField<any>): boolean {
    return field['header'].includes('URL');
  }

  isBoolean(field: ContentRowField<any>): boolean {
    if (!(typeof field.type == 'string')) {
      return false;
    }

    return field.type === 'boolean' || field.type === 'bool';
  }

  getQueryParamsString(field: ContentRowField<any>) {

    if (typeof field.queryParams === 'function') {
      const queryParams = field.queryParams(this.entity) as {};

      const queryParamsString = new HttpParams({fromObject: queryParams});
      return '?' + queryParamsString;
    }
    return '';


  }

  copyToClipboard() {
    if (!this.entity) {
      return;
    }
    let cnt: string;
    if (this.field.copyCellContent) {
      cnt = this.field.copyCellContent(this.entity);
    } else {
      cnt = this.field.cell(this.entity);
    }

    this.clipboard.copy(cnt);
    this.toaster.info('Copied to clipboard: ' + cnt);

  }

  styleObject() {
    const style1: any = {};
    if (this.field.cellColor && this.field.cellColor(this.entity))
      style1.color = this.field.cellColor(this.entity);
    if (this.field.cellBackgroundColor && this.field.cellBackgroundColor(this.entity))
      style1.backgroundColor = this.field.cellBackgroundColor(this.entity)
    if (this.field.cellPadding && this.field.cellPadding(this.entity))
      style1.padding = this.field.cellPadding(this.entity) + 'px';
    if (this.field.cellBorderRadius && this.field.cellBorderRadius(this.entity))
      style1.borderRadius = this.field.cellBorderRadius(this.entity) + 'px';

    return style1;
  }
}

